// components/EventContent/TicketItem.js

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import RadioButton from '../RadioButton/RadioButton';
import Tag from '../Tag';
import { useTranslation } from 'react-i18next';
import { TICKET_FREE } from '../../constants/eventTypes';

const TicketItem = ({ ticket, selected, onSelect }) => {
  const { t } = useTranslation('eventEnroll');
  const handleClick = () => {
    if (ticket.availableSeats > 0) {
      onSelect();
    }
  };

  return (
    <TicketContainer selected={selected} onClick={handleClick} disabled={ticket.availableSeats <= 0}>
      <div style={{ marginTop: "2px" }} >
        <RadioButton selected={selected} onClick={onSelect} />
      </div>
      <TicketContent>
        <TicketData>
          <Typography $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-2-semibold" >{ticket.name}</Typography>
          <Typography $variant="body-1-semibold">
            {ticket.type === TICKET_FREE ? t('ticketSelection.ticketItem.free') : `${ticket.price}€`}

          </Typography>
        </TicketData>
        <TagsWrapper>
          <Tag $variant='subtle' $textStyle='caption-medium' $textTransform='capitalize' $letterSpacing='none' $borderRadius='8px'>
            {/* {ticket.availableSeats} disponible{ticket.availableSeats !== 1 ? 's' : ''} */}
            {t('ticketSelection.ticketItem.seatsAvailable', { count: ticket.availableSeats })}
          </Tag>
          {ticket.approvalRequired && (
            <Tag $variant='brandSubtle' $textStyle='caption-medium' $textTransform='capitalize' $letterSpacing='none' $borderRadius='8px'>
              {t('ticketSelection.ticketItem.approvalRequired')}
            </Tag>
          )}
          {ticket.availableSeats <= 0 && (
            <Tag $variant='danger' $textStyle='caption-medium' $textTransform='capitalize' $letterSpacing='none' $borderRadius='8px'>
              {t('ticketSelection.ticketItem.noSeats')}
            </Tag>
          )}
        </TagsWrapper>
      </TicketContent>
    </TicketContainer>
  );
};

TicketItem.propTypes = {
  ticket: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired, // 'free' o 'paid'
    price: PropTypes.number, // Solo relevante si type === 'paid'
    approvalRequired: PropTypes.bool,
    availableSeats: PropTypes.number.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TicketItem;

// Styled Components
const TicketContainer = styled.li`
  align-items: flex-start;
  background-color: ${({ theme, selected }) => (selected ? theme.fill.defaultMain : theme.fill.defaultMain)};
  border: 2px solid ${({ theme, selected }) => (selected ? theme.border.brandMain : theme.border.defaultSubtle)};
  border-radius: ${({ theme }) => theme.sizing.xs};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.sm};
  justify-content: flex-start;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  padding: ${({ theme }) => theme.sizing.sm};
  transition: border 0.3s ease;
  
  &:hover {
    background-color: ${({ selected, theme }) => (selected ? theme.fill.defaulSubtle : theme.fill.defaultMain)};
    border-color: ${({ selected, theme }) => (selected ? theme.border.brandMain : theme.border.brandMain)};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 12px;
    gap: ${({ theme }) => theme.sizing.xs};
  }
`;

const TicketContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  width: 100%;
`;

const TicketData = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TagsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: flex-start;
`;
